import "./DadosBancarios.css";
import React from 'react';
import Sidebar from '../../menu/Sidebar';
import Topbar from '../../menu/Topbar';
import CardInfosDadosBancarios from "../CardInfosDadosBancarios/CardInfosDadosBancarios";

const DadosBancarios = () => {

    const [menuClose, setMenuClose] = React.useState(false);
    
    const toggleMenu = () => {
        setMenuClose(prev => !prev);
    };

    return(

        <div className="app-container">
            <Sidebar
                close={menuClose} 
                dadosBancariosActive="active"
            />

            <main className="main-content">
                <Topbar page="Conta Bancária" onToggleMenu={toggleMenu} />

                <section className="content">
                    <div className="page-header">
                        <h2>Conta para recebimento</h2>
                        <p>Esses dados serão utilizados exclusivamente para transferências dos valores de comissão.</p>
                    </div>

                    <CardInfosDadosBancarios />
                    
                </section>
            </main>
        </div>

    )

}

export default DadosBancarios;